"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _defer = _interopRequireDefault(require("draft-plugins/lib/defer"));

var _partial = _interopRequireDefault(require("transmute/partial"));

var _TeamInvitationApi = _interopRequireDefault(require("./TeamInvitationApi"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _UITextInput = _interopRequireDefault(require("UIComponents/input/UITextInput"));

var _classnames = _interopRequireDefault(require("classnames"));

var _utils = require("draft-plugins/lib/utils");

var _EmailAddress = _interopRequireDefault(require("PatternValidationJS/patterns/EmailAddress"));

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var SUCCESS_MESSAGE_DELAY = 3000;
var VALIDATION_ERRORS = {
  sendError: 'draftPlugins.tokenPlugin.atMentions.resultsZeroState.teamInvitations.invitationSendError',
  invalidEmail: 'draftPlugins.tokenPlugin.atMentions.resultsZeroState.teamInvitations.invalidEmailError'
};

var _default = (0, _createReactClass.default)({
  displayName: "TeamInvitationForm",
  propTypes: {
    provisioning: _propTypes.default.object.isRequired,
    validate: _propTypes.default.func,
    onInvited: _propTypes.default.func,
    onInviteFailed: _propTypes.default.func,
    onCancel: _propTypes.default.func,
    toggleForcedOverlayFocus: _propTypes.default.func.isRequired,
    search: _propTypes.default.string
  },
  getInitialState: function getInitialState() {
    return {
      inviteeEmail: '',
      inviteSent: false,
      invitePending: false,
      validationError: null
    };
  },
  componentDidMount: function componentDidMount() {
    document.addEventListener('keypress', this.handleKeyCommand);
  },
  componentWillUnmount: function componentWillUnmount() {
    document.removeEventListener('keypress', this.handleKeyCommand);
  },
  handleKeyCommand: function handleKeyCommand(keyboardEvent) {
    var inviteeEmail = this.state.inviteeEmail;
    var keyCode = keyboardEvent.which || keyboardEvent.keyCode; // 13 === enter key

    if (keyCode === 13) {
      keyboardEvent.preventDefault();
      keyboardEvent.stopPropagation();

      if (_EmailAddress.default.test(inviteeEmail)) {
        this.handleSubmitForm();
      }
    }
  },
  handleInputChange: function handleInputChange(e) {
    var inviteeEmail = e.target.value;
    this.setState({
      inviteeEmail: inviteeEmail,
      validationError: null
    });
  },
  handleSubmitForm: function handleSubmitForm() {
    var validate = this.props.validate;
    var inviteeEmail = this.state.inviteeEmail;

    if (!_EmailAddress.default.test(inviteeEmail)) {
      this.setState({
        validationError: _I18n.default.text(VALIDATION_ERRORS.invalidEmail)
      });
      return;
    }

    if (validate) {
      var customValidationError = validate(inviteeEmail);

      if (customValidationError) {
        this.setState({
          validationError: customValidationError
        });
        return;
      }
    }

    this.handleInviteUser(inviteeEmail);
  },
  handleInviteUser: function handleInviteUser(inviteeEmail) {
    var provisioning = this.props.provisioning;
    this.setState({
      invitePending: true,
      validationError: null
    });

    _TeamInvitationApi.default.addUser(inviteeEmail, provisioning).then((0, _partial.default)(this.handleInviteSuccess, inviteeEmail), (0, _partial.default)(this.handleInviteFailed, inviteeEmail)).done();
  },
  handleInviteSuccess: function handleInviteSuccess(inviteeEmail) {
    var onInvited = this.props.onInvited;
    this.setState({
      inviteSent: true,
      invitePending: false,
      validationError: null
    }); // Add token after a timeout if user does not click the confirm button to do so themselves

    this._invitedTimeout = setTimeout(function () {
      onInvited(inviteeEmail);
    }, SUCCESS_MESSAGE_DELAY);
  },
  handleInviteFailed: function handleInviteFailed(inviteeEmail) {
    var onInviteFailed = this.props.onInviteFailed;
    this.setState({
      inviteSent: false,
      invitePending: false,
      validationError: _I18n.default.text(VALIDATION_ERRORS.sendError)
    });
    (0, _defer.default)((0, _partial.default)(onInviteFailed, inviteeEmail));
  },
  handleCancel: function handleCancel() {
    this.props.toggleForcedOverlayFocus(false);
    this.props.onCancel();
  },
  handleConfirmClick: function handleConfirmClick() {
    clearTimeout(this._invitedTimeout);
    this.props.onInvited(this.state.inviteeEmail);
  },
  renderHeader: function renderHeader() {
    var search = this.props.search;

    if (this.state.invitePending || this.state.inviteSent) {
      return null;
    }

    return _react.default.createElement("h5", null, _react.default.createElement(_FormattedHTMLMessage.default, {
      message: "draftPlugins.tokenPlugin.atMentions.resultsZeroState.notFound",
      options: {
        search: search
      }
    }));
  },
  renderInvitationFormContent: function renderInvitationFormContent() {
    var _this$state = this.state,
        invitePending = _this$state.invitePending,
        inviteSent = _this$state.inviteSent;

    if (invitePending) {
      return this.renderInvitePending();
    }

    if (inviteSent) {
      return this.renderInviteSuccessMessage();
    }

    return this.renderInviteFormInput();
  },
  renderInviteFormInput: function renderInviteFormInput() {
    var _this$state2 = this.state,
        inviteeEmail = _this$state2.inviteeEmail,
        validationError = _this$state2.validationError;
    var inputClasses = (0, _classnames.default)('invitee-email-input', {
      'has-error': !!validationError
    });
    return _react.default.createElement("div", {
      className: "team-invite-form"
    }, _react.default.createElement("label", {
      htmlFor: "invitee-email"
    }, _react.default.createElement(_FormattedHTMLMessage.default, {
      message: "draftPlugins.tokenPlugin.atMentions.resultsZeroState.teamInvitations.emailLabel"
    })), _react.default.createElement("div", {
      className: "input-group m-top-2"
    }, _react.default.createElement(_UITextInput.default, {
      name: "invitee-email",
      value: inviteeEmail,
      placeholder: _I18n.default.text('draftPlugins.tokenPlugin.atMentions.resultsZeroState.teamInvitations.placeholderEmail'),
      type: "email",
      onChange: this.handleInputChange,
      className: inputClasses
    }), this.renderValidationErrorMessage(), _react.default.createElement("div", {
      className: "m-top-6"
    }, _react.default.createElement(_UIButton.default, {
      use: "tertiary",
      disabled: !_EmailAddress.default.test(inviteeEmail),
      onClick: this.handleSubmitForm
    }, _react.default.createElement(_FormattedHTMLMessage.default, {
      message: "draftPlugins.tokenPlugin.atMentions.resultsZeroState.teamInvitations.cta"
    })), _react.default.createElement(_UIButton.default, {
      use: "tertiary-light",
      onClick: this.handleCancel
    }, _react.default.createElement(_FormattedHTMLMessage.default, {
      message: "draftPlugins.tokenPlugin.atMentions.resultsZeroState.teamInvitations.cancel"
    })))));
  },
  renderInvitePending: function renderInvitePending() {
    return _react.default.createElement("p", {
      className: "m-y-6 text-center"
    }, _react.default.createElement(_UIImage.default, {
      src: (0, _utils.getImage)('spinner.gif'),
      responsive: false,
      width: 16,
      className: "m-right-2"
    }), _react.default.createElement(_FormattedHTMLMessage.default, {
      message: "draftPlugins.tokenPlugin.atMentions.resultsZeroState.teamInvitations.invitePending"
    }));
  },
  renderInviteSuccessMessage: function renderInviteSuccessMessage() {
    var email = this.state.inviteeEmail;
    return _react.default.createElement("div", {
      className: "success-text"
    }, _react.default.createElement("p", null, _react.default.createElement(_FormattedHTMLMessage.default, {
      message: "draftPlugins.tokenPlugin.atMentions.resultsZeroState.teamInvitations.inviteSent",
      options: {
        email: email
      }
    })), _react.default.createElement(_UIButton.default, {
      use: "tertiary",
      onClick: this.handleConfirmClick
    }, _react.default.createElement(_FormattedHTMLMessage.default, {
      message: "draftPlugins.tokenPlugin.atMentions.resultsZeroState.teamInvitations.confirm"
    })));
  },
  renderValidationErrorMessage: function renderValidationErrorMessage() {
    var validationError = this.state.validationError;

    if (!validationError) {
      return null;
    }

    return _react.default.createElement("p", {
      className: "m-top-2 m-bottom-2 error-text"
    }, validationError);
  },
  render: function render() {
    return _react.default.createElement("div", {
      className: "zero-state-form"
    }, this.renderHeader(), _react.default.createElement("div", {
      className: "team-invite-form"
    }, this.renderInvitationFormContent()));
  }
});

exports.default = _default;
module.exports = exports.default;